import React, { Component } from 'react';
import { Flex, Box } from 'reflexbox';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet-async';
import Text from 'components/Text';

// Modules
import Authorize from 'helpers/Auth';
import { getText } from 'helpers/i18n';

import './error.styles.scss';
import img404 from 'images/paint-into-corner.jpg';

export default class Error extends Component {
    componentDidMount() {
        document.body.classList.add('checkout-error');
        window.scrollTo(0, 0);

        // Initialize authorize module to be used sitewide.
        if (!window.Checkout.auth) {
            window.Checkout.auth = new Authorize();
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('checkout-error');
    }

    render() {
        return (
            <Flex column className="errorpage">
                <Helmet>
                    <title>{getText('error_not_found_headline')}</title>
                </Helmet>
                <Box w={1} p={2} align="center" className="errorpage__container">
                    <h4><Text textKey="error_not_found_headline" /></h4>
                    <p><Text textKey="error_not_found_text1" /></p>
                    <p><Text textKey="error_not_found_text2" /></p>
                    <div className="errorpage__links">
                        <a href={window.Checkout.settings.error_not_found_home_url}><Text textKey="error_not_found_home_text" /></a>
                        <a href={window.Checkout.settings.error_not_found_shoppinglist_url}><Text textKey="error_not_found_shoppinglist_text" /></a>
                    </div>
                    <img src={img404} alt="" />
                </Box>
            </Flex>
        );
    }
}

Error.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};
